var reflowFallbackImage = angular.module('cpm').directive("reflowFallbackImage", function($compile){
	return {
		restrict: "E",
		template: "<div class='contents'></div>",
		scope: {
			adunit: "="
		},
		link: function($scope, $element, $attrs) {

			$scope.isDraggedOver = [];
			
			
			$scope.$watch("adunit.fallbackImage", function() {
				
				var markup;
				
				if("undefined" !== typeof $scope.adunit && $scope.adunit != null) {
					
					var width = 254;

					let canvas = $scope.adunit.canvases[0];
					if(!!$scope.adunit.deviceroots.desktop) {
						let dekstopRootId = $scope.adunit.deviceroots.desktop;
						let c = $scope.adunit.canvases.find( (c) => c.id == dekstopRootId);
						if(!!c) {
							canvas = c;
						}
					}

					var height = canvas.height / canvas.width * width;
					
					if("undefined" !== typeof $scope.adunit.fallbackImage && $scope.adunit.fallbackImage != null) {

						var asset = $scope.adunit.assets[$scope.adunit.fallbackImage];
						if(!!asset) {

							let closeMarkup = "<i class='fa fa-times' style='font-size: 2em; position: absolute; top:0; left:" + asset.width + "px;'></i>";
							let closeElement = $("<i class='fa fa-times'></i>");
							markup = "<img src='https://storage.googleapis.com/assets-scenestealer-210713/" + asset.src + "' class='fallback-image' />";

							//TODO have a mask that displays on hover
							let fallbackImageElement = ($(".contents", $element).html(markup));
							closeElement.css({ position: "absolute", "text-align": "right", right: "5px", cursor: "pointer", "font-size": "2em" });
							$(".contents").prepend(closeElement);

							closeElement.click(() => {
								$scope.adunit.fallbackImage = undefined;
								$scope.$apply();
							});

							
							if(!(asset.width == canvas.width && asset.height == canvas.height)) {
								$(".contents", $element).prepend("<div class='alert alert-danger'>The dimensions of the fallback image do not match that of the default canvas!</div>");
							}
							
							$(".propGroupHeading", $element).text("Fallback Image - " + asset.name);

						}
						else {
							$(".propGroupHeading", $element).text("Fallback Image - Missing Asset");
							markup = "<div style='width: 100%; height: 100%; background-color: gray;'></div>";
							$(".contents", $element).html(markup);
						}
							
					}
					else {
						
						var markup = "<div style='width: 100%; height: " + height + "px;' class='fallback-image-empty'>"
						markup += "<span>No fallback image set. Drag an image from the library to set a fallback image.</span>";
						markup += "</div>";
						
						$(".contents", $element).html(markup);
					}
					
				}
				else {
					var markup = "<div style='width: 100%; height: " + height + "px;' class='fallback-image-empty'>"
					markup += "<span>No fallback image set. Drag an image from the library to set a fallback image.</span>";
					markup += "</div>";
					
					$(".contents", $element).html(markup);
				}
								
				
			}, true);
			
			
			
			$element.droppable({ 
				accept: (draggable) => {
					var widget = $(draggable).data("reflow-asset");
                    return (!!widget) ? widget.contentType.startsWith('image/') : false;

				},
				over: function(ev, ui) {

					//over and out event execution orders cause problems, executing the over
					//event after the out looks to fix this.
    				setTimeout(() => {

						$(".contents", $element).css("border", "2px dashed green");

						$.each($('.ui-droppable'), (index, value) => {
							if(ev.target != value) {
								$(value).droppable("option", "disabled", true);

								if($(value).hasClass("drag-over")) {
									$(value).removeClass("drag-over");
									$scope.isDraggedOver.push($(value));
								}
							}
						});
					}, 0);

				},
				out: function(ev, ui) {

					$.each($('.ui-droppable'), (index, value) => {
						if(ev.target != value) {
							$(value).droppable("option", "disabled", false);

							$scope.isDraggedOver.forEach(el => {
								el.addClass('drag-over');
							});
						}
					});

					$scope.isDraggedOver = [];

					$(".contents", $element).css("border", "");
		       },
		       drop: function(ev, ui) {
					$(".contents", $element).css("border", "");

					var asset = $(ui.draggable).data("reflow-asset");

					$.each($('.ui-droppable'), (index, value) => {
						if(ev.target != value) {
							$(value).droppable("option", "disabled", false);
						}
					});

					$scope.isDraggedOver = [];
					
					if(!!asset) {						
						$scope.adunit.fallbackImage = asset._id;
						$scope.adunit.assets[asset._id] = asset;												
					}

					$scope.$apply();
					
				} 
			});
			
		}
		
	};
});
